import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from '@material-ui/core/InputAdornment';
import TimeFieldMask from "./TimeFieldMask";
import { ReactComponent as ClockIcon } from './clock.svg';

export default class TimeComponent extends PureComponent {

  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    timeErrors: PropTypes.bool.isRequired,
  };

  render = () =>
    <div className={this.props.classes.timeBlock}>
      <TextField
        value={this.props.value}
        label=""
        variant="outlined"
        InputProps={{
          inputComponent: TimeFieldMask,
          endAdornment: (
            <InputAdornment position="end">
              <ClockIcon/>
            </InputAdornment>
          )
        }}
        error={this.props.timeErrors}
        autoFocus={false}
        onChange={(time) => this.props.onChange(time)}
        helperText={ this.props.timeErrors ? "Incorrect time" : ""}
      />
    </div>;
}
